

export const FETCH_DOCUMENT_REQUEST = 'FETCH_DOCUMENT_REQUEST';
export const FETCH_DOCUMENT_REQUEST_COMPLETED = 'FETCH_DOCUMENT_REQUEST_COMPLETED';
export const FETCH_DOCUMENT_REQUEST_ERROR = 'FETCH_DOCUMENT_REQUEST_ERROR';
export const FETCH_DOCUMENT_RESET = 'FETCH_DOCUMENT_RESET';

export const FETCH_DOCUMENT_LIST_REQUEST = 'FETCH_DOCUMENT_LIST_REQUEST';
export const FETCH_DOCUMENT_LIST_REQUEST_COMPLETED = 'FETCH_DOCUMENT_LIST_REQUEST_COMPLETED';
export const FETCH_DOCUMENT_LIST_REQUEST_ERROR = 'FETCH_DOCUMENT_LIST_REQUEST_ERROR';
export const FETCH_DOCUMENT_LIST_RESET = 'FETCH_DOCUMENT_LIST_RESET';

export const FETCH_DOCUMENT_USER_LIST_REQUEST = 'FETCH_DOCUMENT_USER_LIST_REQUEST';
export const FETCH_DOCUMENT_USER_LIST_REQUEST_COMPLETED = 'FETCH_DOCUMENT_USER_LIST_REQUEST_COMPLETED';
export const FETCH_DOCUMENT_USER_LIST_REQUEST_ERROR = 'FETCH_DOCUMENT_USER_LIST_REQUEST_ERROR';

export const ADD_DOCUMENT_INITIAL = 'ADD_DOCUMENT_INITIAL';
export const ADD_DOCUMENT_REQUEST = 'ADD_DOCUMENT_REQUEST';
export const ADD_DOCUMENT_REQUEST_COMPLETED = 'ADD_DOCUMENT_REQUEST_COMPLETED';
export const ADD_DOCUMENT_REQUEST_ERROR = 'ADD_DOCUMENT_REQUEST_ERROR';

export const UPDATE_FILE_REQUEST = 'UPDATE_FILE_REQUEST';
export const UPDATE_FILE_REQUEST_COMPLETED = 'UPDATE_FILE_REQUEST_COMPLETED';
export const UPDATE_FILE_REQUEST_ERROR = 'UPDATE_FILE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/documentdetails.js